import acordeon from "../lib/aria/acordeon";
var preguntasFrecuentes = function () { return acordeon('.preguntas_frecuentes__preguntas', false); };
export default preguntasFrecuentes;
